// features/checkout/services/validateCheckoutForm.ts

import { CheckoutFormData } from '../dto/CheckoutFormData'

// Only the keys we care about
export type CheckoutErrors = Record<
    keyof Pick<
        CheckoutFormData,
        | 'firstname'
        | 'lastname'
        | 'address1'
        | 'postalcode'
        | 'city'
        | 'country'
        | 'tos'
    >,
    string
>

/**
 * Validates the client-info part of the checkout form.
 * @param form  The raw form data.
 * @param t     The translation function (i18n).
 * @returns     An object with empty strings for valid fields, or localized error messages.
 */
export function validateCheckoutFormClientInformation(
    form: CheckoutFormData,
    t: (key: string) => string
): CheckoutErrors {
    const errors: CheckoutErrors = {
        firstname: '',
        lastname: '',
        address1: '',
        postalcode: '',
        city: '',
        country: '',
        tos: '',
    }

    if (!form.firstname.trim()) {
        errors.firstname = t('checkout.validation.firstnameRequired')
    }
    if (!form.lastname.trim()) {
        errors.lastname = t('checkout.validation.lastnameRequired')
    }
    if (!form.address1.trim()) {
        errors.address1 = t('checkout.validation.addressRequired')
    }
    if (!form.postalcode.trim()) {
        errors.postalcode = t('checkout.validation.postalCodeRequired')
    }
    if (!form.city.trim()) {
        errors.city = t('checkout.validation.cityRequired')
    }
    if (!form.country.trim()) {
        errors.country = t('checkout.validation.countryRequired')
    }
    if (!form.tos) {
        errors.tos = t('checkout.validation.tosAgreementRequired')
    }

    return errors
}
